module.exports = __webpack_public_path__ + "img/b13.395f064a.png";